

<template>
  <!-- 医院简介 -->
  <div class="container-width honor-block" @click="goArticle">
    <vue-seamless-scroll
      :data="Data"
      :class-option="classOption"
      style="width: 100%; overflow: hidden; margin-bottom: 30px"
    >
    <!--  v-if="index != 0" -->
      <div class="honor_swiper">
        <ul class="swiper-wrapper">
          <li
            class="swiper-slide"
            v-for="(item, index) in Data"
            :key="index"           
            nextMargin="30px"
            :data-index="index"
          >
            <div>
              <p class="time">{{ item.title }}</p>
              <div class="department">
                <p>{{ item.introduction }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </vue-seamless-scroll>
  </div>
</template>
      
<script>
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "ARTICLE",
  props: {
    Data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      classOption: {
        //滚动的配置项
        step: 2,
        direction: 2,
      },
    };
  },
  methods: {
    goArticle(e) {
      const item = e.target.closest(".swiper-slide"); // 定位元素
    

      if (item) {
        // 是否是滚动组件的某一行/列
        const { index } = item.dataset;
        // console.log("data", this.Data[index]); // 你想获取的数据
        // 后续操作
        let articleId = this.Data[index].id;
        const { href } = this.$router.resolve({
          path: `/yygk/article`,
          query: {
            id: `${articleId}`,
          },
        });
        window.open(href, "_blank");
      }
    },
  },
  mounted() {},
  watch: {},
  created() {},
  destroyed() {},
};
</script>
      
<style scoped lang="scss">
.honor-block {
  margin-top: 50px;
  .honor_swiper {
    width: 100%;
    height: 186px;
    overflow: hidden;
    box-sizing: content-box;
    padding-top: 24px;
    .swiper-slide {
      width: 300px;
      height: 186px;
      cursor: pointer;
    }
    .swiper-slide:last-child {
      padding-right: 0px;
    }
    ul {
      height: 186px;
      li {
        height: 186px;
        float: left;
        box-sizing: border-box;
        cursor: pointer;
        p {
          text-align: center;
        }
      }
      li:first-child {
        margin-left: 0;
      }

      li > div {
        width: 285px;
        height: 186px;
        padding-top: 20px;
        margin: 0 auto;
        box-sizing: border-box;
        border-bottom: 6px solid #00479d;
        box-shadow: 0 2px 20px rgba(0, 0, 0, 0.12);
        .time {
          font-size: 1.4rem;
          color: #00479d;
          font-weight: bold;
          line-height: 24px;
        }
        .department {
          margin: 10px auto 0;
          box-sizing: border-box;
          border: 2px solid #f0f0f0;
          width: 240px;
          height: 100px;
          border-radius: 8px;
          padding: 16px 16px;
          font-size: 14px;
          line-height: 20px;
          overflow-y: auto;
          p {
            font-size: 14px;
            line-height: 20px;
            color: #333333;
            text-align: left;
          }
          p:first-child {
            font-weight: bold;
          }
        }
        .department::-webkit-scrollbar-track {
          background-color: #f7f8fa;
        }
        .department::-webkit-scrollbar {
          width: 4px;
          height: 4px;
          background-color: #ddd;
        }
        .department::-webkit-scrollbar-thumb {
          background-color: #ddd;
          border-radius: 2px;
        }
      }
    }
  }

  ::-webkit-scrollbar-corner {
    border-radius: 2px;
  }
}
@media only screen and (max-width: 768px) {
  .honor-block {
    margin-top: 20px;
    .honor_swiper {
      height: 156px;
      ul {
        height: 156px;
        .swiper-slide {
          width: 260px;
        }
        li {
          height: 156px;
        }

        li > div {
          width: 245px;
          height: 156px;
          padding-top: 20px;
          margin: 0 auto;
          box-sizing: border-box;

          .department {
            width: 200px;
            height: 80px;
            p {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
/* 小屏幕（平板，大于等于 420px） */
@media only screen and (max-width: 420px) {
  .honor-block {
    margin-top: 20px;
    .honor_swiper {
      height: 156px;
      padding-top: 24px;
      ul {
        height: 156px;
        .swiper-slide {
          width: 240px;
        }
        li {
          height: 156px;
        }
        li > div {
          width: 225px;
          height: 156px;

          .department {
            width: 200px;
            height: 80px;
            p {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
      
    
       